import React from 'react'
import clsx from 'clsx'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG, WithChildren } from '../../../helpers'

type Props = {
	to: string
	title: string
	icon?: string
	customIcon?: JSX.Element
	fontIcon?: string
	hasBullet?: boolean
	isOutsideMenu?: boolean
}

const AsideMenuItemWithSub: React.FC<Props & WithChildren> = ({
	children,
	to,
	title,
	icon,
	customIcon,
	fontIcon,
	hasBullet,
	isOutsideMenu,
}) => {
	const { pathname } = useLocation()
	const isActive = checkIsActive(pathname, to)
	const [forceOpen, setForceOpen] = React.useState(false)

	const onForceClick = () => {
		if (isOutsideMenu) {
			setForceOpen(!forceOpen)
		}
	}

	return (
		<div
			className={clsx('menu-item', { 'here show': isActive || forceOpen }, 'menu-accordion')}
			onClick={onForceClick}
			data-kt-menu-trigger="click">
			<span className="menu-link bg-transparent">
				{hasBullet && (
					<span className="menu-bullet">
						<span className="bullet bullet-dot"></span>
					</span>
				)}
				{(customIcon || icon) && (
					<span className="menu-icon me-1">
						{customIcon ? customIcon : icon && <KTSVG path={icon} className="svg-icon-2" />}
					</span>
				)}
				{fontIcon && <i className={clsx('bi fs-3', fontIcon)}></i>}
				<span className="menu-title fw-bold text-kumopack-grey-700">{title}</span>
				<span className="menu-arrow"></span>
			</span>
			<div className={clsx('menu-sub menu-sub-accordion', { 'menu-active-bg': isActive })}>
				{children}
			</div>
		</div>
	)
}

export { AsideMenuItemWithSub }
